#import "~/graphql/fragments/assets/defaultImageAsset.graphql"

fragment flexibleTeamMembers on flexibleSections_teamMembers_BlockType {
    __typename
    title: plaintext
    subtitleTeamMembers {
        ... on teamMemberSection_Entry {
            id
            teamMembers {
                ... on teamMembers_default_Entry {
                    title
                    email: plainEmail
                    phoneNumber: plaintext
                    function: plaintext2
                    department: selectTeamDepartment {
                        title
                    }
                    showLink: plainSwitch
                    uri
                    image {
                        ... DefaultImageAsset
                    }
                }
            }
            subTitle
        }
    }
}
